export const STRING_SCHEMA = {type: 'string'};

// --- Shared validation rules ---
const REQUIRED_RULE = {type: 'required', msg: ' is required'};
const MAX_LENGTH_60_RULE = {
  type: 'maxLength',
  limit: 60,
  msg: ' must be less than or equal to 60 characters'
};

// --- Shared field definitions ---
const SHARED_FIELDS = {
  title: {
    label: 'Title*',
    placeholder: 'New Display',
    isDark: true,
    validationRules: [REQUIRED_RULE, MAX_LENGTH_60_RULE]
  },
  category: {
    label: 'Category for Target title',
    placeholder: 'New Category for Target title',
    isDark: true
  },
  excerpt: {
    label: 'Excerpt*',
    placeholder: 'Type here',
    className: 'w-full',
    helperText: '',
    showToolbar: true,
    maxLength: 500,
    isDark: true,
    validationRules: [REQUIRED_RULE]
  },
  terms: {
    label: 'Terms*',
    placeholder: 'Type here',
    className: 'w-full',
    showToolbar: true,
    maxLength: 500,
    isDark: true,
    validationRules: [REQUIRED_RULE]
  }
};

// --- DisplayContentTab field configs (main / layered / earlyPayment) ---
export const DISPLAY_CONTENT_FIELD_CONFIG = {
  title: SHARED_FIELDS.title,
  titleEarlyPayment: {
    label: 'Title*',
    placeholder: 'Title',
    helperText: '60 max characters',
    isDark: true,
    validationRules: [REQUIRED_RULE, MAX_LENGTH_60_RULE]
  },
  category: SHARED_FIELDS.category,
  pointsEarned: {
    label: 'Points Earned *',
    placeholder: 'Enter points',
    className: 'box-size-width text-sm',
    isDark: true,
    validationRules: [REQUIRED_RULE, {type: 'number', msg: ' must be a number'}]
  },
  parentCategory: {
    label: 'Parent Category',
    placeholder: 'Add Parent Category',
    isDark: true
  },
  childCategory: {
    label: 'Child Category',
    placeholder: 'Add Child Category',
    isDark: true
  },
  excerpt: SHARED_FIELDS.excerpt,
  excerptLayered: {
    label: 'Excerpt',
    placeholder: 'Type here',
    className: 'w-full',
    helperText: '',
    showToolbar: true,
    maxLength: 500,
    isDark: true
  },
  terms: SHARED_FIELDS.terms,
  termsLayered: {
    label: 'Terms',
    placeholder: 'Type here',
    className: 'w-full',
    helperText: 'Campaign Conditions',
    showToolbar: true,
    maxLength: 500,
    isDark: true
  },
  termsEarlyPayment: {
    label: 'Terms',
    placeholder: 'Type here',
    className: 'w-full',
    helperText: 'Campaign Conditions',
    showToolbar: true,
    maxLength: 500,
    isDark: true
  },
  description: {
    label: 'Description*',
    placeholder: 'Type here',
    className: 'w-full',
    helperText: 'Description text',
    showToolbar: true,
    maxLength: 500,
    isDark: true,
    validationRules: [REQUIRED_RULE]
  }
};

// --- DisplayPreReqContentTab field configs ---
export const PRE_REQ_FIELD_CONFIG = {
  title: {
    label: 'Title*',
    placeholder: 'Title',
    maxLength: '40',
    isDark: true,
    validationRules: [REQUIRED_RULE, MAX_LENGTH_60_RULE]
  },
  category: SHARED_FIELDS.category,
  excerpt: {
    label: 'Excerpt*',
    placeholder: 'Excerpt',
    showToolbar: true,
    maxLength: 500,
    isDark: true,
    validationRules: [REQUIRED_RULE]
  },
  terms: SHARED_FIELDS.terms
};
